import {useEffect, useState} from 'react';

/** Должно совпадать с $bp-mobile в styles/_breakpoints.scss */
const MOBILE_QUERY = '(max-width: 767px)';

const getMatches = (query: string): boolean =>
  typeof window !== 'undefined' &&
  typeof window.matchMedia === 'function' &&
  window.matchMedia(query).matches;

/** true на телефоне; следит за ресайзом и поворотом экрана. */
export const useIsMobile = (): boolean => {
  const [isMobile, setIsMobile] = useState(() => getMatches(MOBILE_QUERY));

  useEffect(() => {
    if (typeof window.matchMedia !== 'function') return;
    const query = window.matchMedia(MOBILE_QUERY);
    const onChange = (event: MediaQueryListEvent) => setIsMobile(event.matches);

    query.addEventListener('change', onChange);
    return () => query.removeEventListener('change', onChange);
  }, []);

  return isMobile;
};

export default useIsMobile;
